import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { narrowType, nonEmptyArray } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { selectOrderedColumns } from 'components/Table/model/selectors/selectOrderedColumns';
import type { TableCommandFactory } from '../TableModel';

export interface SortTableSettingsColumnsCommand {
  dragIndex: number;
  hoverIndex: number;
}

export const sortTableSettingsColumns: TableCommandFactory<
  SortTableSettingsColumnsCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    // We must pick orderedColumns from this selector to use the same source as TableSettings component,
    // draft.settings.orderedColumns may be out of sync e.g. when a column in table is added or removed
    // in new app version.
    const orderedColumns = [
      ...selectOrderedColumns(cmdContext.getState()).map(prop('key')),
    ];
    const draggedColumn = orderedColumns[command.dragIndex];
    if (draggedColumn === undefined) {
      stumble('Invalid dragged column index');
      return;
    }

    orderedColumns.splice(command.dragIndex, 1);
    orderedColumns.splice(command.hoverIndex, 0, draggedColumn);
    // should never be empty as the line above inserts element
    draft.settings.orderedColumns = narrowType(
      nonEmptyArray.isNonEmpty,
      orderedColumns,
    );
  });
};
